import { Item, Section } from "react-stately";
import {
  CollectionItemProps,
  CollectionSectionProps,
} from "./collections.types";

export const CollectionItem = Item as <T>(
  props: CollectionItemProps<T>
) => JSX.Element;

export const CollectionSection = Section as <T>(
  props: CollectionSectionProps<T>
) => JSX.Element;
